import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { Modal } from "react-bootstrap";
import http from "../../../common/http-common";
import * as common from "../../../common/common";
import * as Comp from "../../../common/CommonComponents";
import save from "../../../assets/save-icon.png";
import cancel from "../../../assets/cancel-icon.png";
import { toast } from "react-toastify";

const UserResetPassword = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  // const userIdInputRef = useRef();
  const emailInputRef = useRef();
  const userNameInputRef = useRef();
  const userPasswordInputRef = useRef();
  const userCPasswordInputRef = useRef();

  const [editData, setEditData] = useState([]);
  const [inputError, setInputError] = useState([]);

  useEffect(() => {
    if (props.editData !== null) {
      setEditData({
        USER_ID: props.editData.USER_ID === null ? "" : props.editData.USER_ID,
        USER_SHORT_NAME:
          props.editData.USER_SHORT_NAME === null
            ? ""
            : props.editData.USER_SHORT_NAME,
        EMAIL: 
          props.editData.EMAIL === null ? "" : props.editData.EMAIL,
      });
    }
  }, [props.editData]);

  const hideModal = () => {
    setEditData([]);
    setInputError([]);
    props.onHide();
  };

  const saveBtnOnClick = () => {
    if (editData.DEFAULT_PASSWORD === undefined) {
      setInputError((prevState) => ({
        ...prevState,
        DEFAULT_PASSWORD: " Password could not be empty.",
      }));
    } else {
      furtherValidateInput("DEFAULT_PASSWORD", editData.DEFAULT_PASSWORD);
    }
    if (Object.values(inputError).filter((v) => v !== "").length === 0) {
      SaveEditUser();
    }
  };

  function SaveEditUser() {
    let functionName = "";
    try {
      functionName = SaveEditUser.name;
      props.onLoading(true, "Modifying user, please wait...");
      var encrypted = common.c_EncryptData(editData.DEFAULT_PASSWORD.trim());
      const data = {
        USER_ID: editData.USER_ID,
        USER_SHORT_NAME: editData.USER_SHORT_NAME,
        DEFAULT_PASSWORD: encrypted.toString(),
        UPDATE_ID: userId,
        FROM_SOURCE: { SOURCE: "WEB" /*MODULE_ID: props.module*/ },
      };
      http
        .put("api/users/ResetPassword", data, { timeout: 5000 })
        .then((response) => {
          toast.success("User password is successfully reset.");
          props.onReload();
          hideModal();
        })
        .catch((err) => {
          toast.error("Failed to reset user password. Please try again.1");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        });
    } catch (err) {
      props.onLoading(false, "Loading...");
      toast.error("Failed to reset user password. Please try again.2");
      common.c_LogWebError(props.page, functionName, err);
    }
  }

  function furtherValidateInput(id, val) {
    if (id === "DEFAULT_PASSWORD") {
      var CONFIRM_PASSWORD = editData.CONFIRM_PASSWORD;
      if (CONFIRM_PASSWORD !== val) {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: "Please confirm the passwords are match.",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: "",
        }));
      }
    } else {
      var DEFAULT_PASSWORD = editData.DEFAULT_PASSWORD;
      if (DEFAULT_PASSWORD !== val) {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: "Please confirm the passwords are match.",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: "",
        }));
      }
    }
  }

  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: name + " could not be empty.",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
        furtherValidateInput(id, val);
      }
      setEditData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered>
        <Modal.Header>
          <div style={{ backgroundColor: "lightgrey", width: "100%" }}>
            <Modal.Title>RESET PASSWORD</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          {/* <Comp.Input
            ref={userIdInputRef}
            id="USER_ID"
            label="User Id:"
            type="text"
            className="form-control"
            value={editData.USER_ID}
            readOnly={true}
          /> */}
          <Comp.Input
            ref={emailInputRef}
            id="EMAIL"
            label="Email*:"
            name="Email"
            type="text"
            className="form-control"
            errorMessage={inputError.EMAIL}
            value={editData.EMAIL}
            readOnly={true}
          />
          <Comp.Input
            ref={userNameInputRef}
            id="USER_SHORT_NAME"
            label="User Name:"
            type="text"
            className="form-control"
            value={editData.USER_SHORT_NAME}
            readOnly={true}
          />
          <Comp.Input
            ref={userPasswordInputRef}
            id="DEFAULT_PASSWORD"
            label="Password*:"
            name="Password"
            type="password"
            className="form-control"
            errorMessage={inputError.DEFAULT_PASSWORD}
            value={editData.DEFAULT_PASSWORD}
            onChange={inputRequiredHandler}
          />
          <Comp.Input
            ref={userCPasswordInputRef}
            id="CONFIRM_PASSWORD"
            label="Confirm Password*:"
            name="Confirm Password"
            type="password"
            className="form-control"
            errorMessage={inputError.CONFIRM_PASSWORD}
            value={editData.CONFIRM_PASSWORD}
            onChange={inputRequiredHandler}
          />
        </Modal.Body>
        <Modal.Footer>
          <div style={{ textAlign: "center", width: "100%" }}>
            <Comp.Button id="btnSave" onClick={saveBtnOnClick}>
              Save  <img src={save} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
            </Comp.Button>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            <Comp.Button id="btnCancel" type="cancel" onClick={hideModal}>
              Cancel  <img src={cancel} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UserResetPassword;
